import { DefaultAuthClient } from './_default_auth_client.js';
export function createAuthClient(options) {
    return new DefaultAuthClient(options);
}
//# sourceMappingURL=auth_client.js.map